
import NotFound from '../views/notfound/NotFound.vue'



const routes = [
    {//官网
        path: "/",
        redirect: "/home"
    },
    {
        path: "/:pathMatch(.*)*",
        name: "Notfound",
        component: NotFound
    }
]

export default routes